var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createSubcomponent, styled, getCanvasTheme, } from '@workday/canvas-kit-react/common';
import { space } from '@workday/canvas-kit-react/tokens';
import { Popup } from '@workday/canvas-kit-react/popup';
import { useModalCard, useModalModel } from './hooks';
var ResponsiveModalCard = styled(Popup.Card)(function (_a) {
    var _b;
    var theme = _a.theme;
    var canvasTheme = getCanvasTheme(theme);
    return _b = {
            margin: space.xl
        },
        _b[canvasTheme.breakpoints.down('s')] = {
            margin: space.s,
            padding: space.xxs,
            borderRadius: space.m,
        },
        _b;
});
export var ModalCard = createSubcomponent('div')({
    displayName: 'Modal.Card',
    modelHook: useModalModel,
    elemPropsHook: useModalCard,
})(function (elemProps, Element) {
    return React.createElement(ResponsiveModalCard, __assign({ as: Element, width: 440, borderWidth: 0, depth: 6 }, elemProps));
});
